export default "__VITE_ASSET__CDeGohke__"